import React, { useState, useEffect } from "react";
import plus from "../../../src/assets/Images/plus.svg";
import { Breadcrumb } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { SetHeading } from "../../context/NavbarContext";
import { routes } from "../../Routes";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { Link, useLocation, useNavigate } from "react-router-dom";
import i18next from "i18next";
import {
  getPosSessionHistory,
  getPosSessionList,
} from "../../API  Functions/SessionHistoryFunctions";
import CloseSessionModal from "../../modals/CloseSession_Modal";
import { Drawer } from "antd";
import { DatePicker, Select, ConfigProvider } from "antd";
import {
  createPurchaseOrder,
  getBillPaymentHistory,
  getPaymentsList,
  getPurchaseList,
} from "../../API  Functions/PurchaseFunctions";
import moment from "moment";
import PurchasePayment from "../../modals/purchasePaymentModal";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import LoadingSpinner from "../../components/Loading";
import { DeleteOutlined } from "@ant-design/icons";
import SelectBox from "../../components/CustomWidgets/EOrderFilter";
import dayjs from "dayjs";
import DateFilter from "../../components/ui/DateFilter";

const today = dayjs();

const formatToday = today.format("YYYY-MM-DD");
const startofMonth = today.startOf("month").format("YYYY-MM-DD");

const PurchaseList = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );

  const navigate = useNavigate();

  const [popup, setpopup] = useState(false);
  const [selectedBillId, setSelectedBillId] = useState(null);
  const [selectedDueAmount, setSelectedDueAmount] = useState(null);
  const [visible, setVisible] = useState(false);
  const [paymentHistoryData, setPaymentHistoryData] = useState([]);
  const [drawerData, setDrawerData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedPaymentType, setSelectedPaymentType] = useState(
    t("all_orders"),
  );

  const [dateRange, setDateRange] = useState([null, null]);
  const [noOrdersFound, setNoOrdersFound] = useState(false);
  const [fetchedOrdersCount, setFetchedOrdersCount] = useState(0); // Track the number of orders fetched
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [data, setData] = useState([]);
  const location = useLocation();
  const fromPage = location.state?.from;
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );
  const orderIdToOpen = location.state?.orderId;

  const [selectedRange, setSelectedRange] = useState("thisMonth");

  const showDrawer = (historyData) => {
    setDrawerData(historyData);
    setVisible(true);
    getPaymentHistory(historyData.bill_id);
    setSelectedUserId(historyData.bill_id);
  };

  useEffect(() => {
    getSessionList("", selectedPaymentType, 0, startofMonth, formatToday);
  }, [popup]);

  // useEffect(() => {
  //   console.log("ORDER ID TO OPEN", orderIdToOpen, data);
  //   console.log("Order Nos in data:", data.map(d => d.order_details?.order_no));

  //   if (orderIdToOpen && data.length > 0) {
  //     const matchingOrder = data.find(
  //       (order) => order?.order_details?.order_no === orderIdToOpen
  //     );

  //     if (matchingOrder) {
  //       handleBoxClick(matchingOrder);
  //     }
  //   }
  // }, [data, orderIdToOpen]);

  useEffect(() => {
    if (fromPage === "vendor_payment" && orderIdToOpen) {
      // Automatically search and open the order
      getSessionList(
        orderIdToOpen,
        selectedPaymentType,
        0,
        startofMonth,
        formatToday,
        true,
      );
    }
  }, [fromPage, orderIdToOpen]);

  const getPaymentHistory = (billId) => {
    const payload = {
      bill_id: billId,
    };
    getBillPaymentHistory(payload)
      .then((res) => {
        if (res?.result?.payments.length > 0) {
          setPaymentHistoryData(res?.result?.payments);
          setLoading(false);
        } else {
          console.error("No session history found");
        }
      })
      .catch((error) => {
        console.error("Error fetching session history:", error);
      });
  };
  const onClose = () => {
    setVisible(false);
  };

  const getSessionList = (
    search = "",
    paymentType = "all",
    offset,
    startDate,
    endDate,
    shouldAutoOpen = false,
  ) => {
    setLoading(true);
    let paymentStatus = "";
    if (paymentType === 1) {
      paymentStatus = "draft";
    } else if (paymentType === 2) {
      paymentStatus = "done";
    }
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
      state: paymentStatus,
      order_no: search,
      limit: 10,
      offset: offset * 10,
      start_date: startDate || "",
      end_date: endDate || "",
    };

    getPurchaseList(payload)
      .then((res) => {
        // console.log("PURCHASSE LIST ", res);

        if (res?.result[0]?.status_code == 200) {
          const AllList = res?.result[0]?.response;
          //   console.log("AllList", AllList);
          setData(AllList);
          setFetchedOrdersCount(AllList.length);
          setLoading(false);

          setNoOrdersFound(false);

          if (shouldAutoOpen && search && AllList.length > 0) {
            const matchingOrder = AllList.find(
              (order) => order?.order_details?.order_no === search,
            );
            if (matchingOrder) {
              handleBoxClick(matchingOrder);
            }
          }
        } else {
          console.error("Response was not successful:", res);
          setData([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching store users:", error);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   getSessionList();
  // }, []);

  const handlePaymentClick = (val) => {
    setSelectedBillId(val?.bill_id);
    setSelectedDueAmount(val?.due_amount);
    setIsModalVisible(true);
  };

  const handleSearchChange = (value) => {
    setSearchKeyword(value);
    getSessionList(value, selectedPaymentType, 0);
  };

  const handlePaymentTypeChange = (event) => {
    const paymentType = event.target.value;
    setSelectedPaymentType(paymentType);
    getSessionList(searchKeyword, paymentType, 0, startDate, endDate);
  };

  const options = [
    {
      value: 0,
      label: `${t("all_orders")}`,
    },
    {
      value: 1,
      label: `${t("Draft Orders")}`,
    },
    {
      value: 2,
      label: `${t("Purchase Orders")} `,
    },
  ];

  //   console.log("CURRENT PAGE ", currentPage);
  const formatSessionState = (state) => {
    if (!state) return "";

    if (state === "Unpaid") return t("Draft Order");
    if (state === "not_paid") return t("Unpaid");

    return state
      .split("_") // Split by underscore
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words with a space
  };

  const handleBoxClick = (val) => {
    console.log("VVVVVVV", val);
    if (val.order_details.status === "draft") {
      navigate(routes.purchase.addBill, {
        state: { orderData: val, from: fromPage },
      });
    } else {
      navigate(routes.purchase.purchaseOrder, {
        state: { orderData: val, from: fromPage },
      });
    }
  };

  const handleDelete = async (val) => {
    setLoading(true);

    const payload = {
      po_id: val.order_details.order_id,
      user_id: user_id,
      company_id: company_id,

      date_of_bill: val.order_details.order_date,
      vendor_reference: val.order_details.venfor_ref,
      state: "delete",
      lines: val.lines,
    };

    // console.log("Payload for purchase order:", payload);

    try {
      const response = await createPurchaseOrder(payload);
      console.log("Draft order created successfully:", response);

      if (response.result.status_code === 200) {
        setSelectedPaymentType("Draft Orders");
        getSessionList("", selectedPaymentType, 0);
        setLoading(false);
      } else if (response.result.status_code === 400) {
        setLoading(false);
      }
    } catch (error) {
      console.error("Failed to create purchase order:", error);
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingSpinner />}

      <div className="w-full flex flex-col overflow-y-auto bg-[#F6F7F9]">
        <SetHeading value="Purchase History" />

        <div className="overflow-y-auto overflow-hidden custom-scrollbar">
          <div className="px-2 md:px-5 font-extrabold">
            {/* Search + Filters */}
            <div className="flex flex-col lg:flex-row justify-between lg:items-end gap-4 mt-2">
              <div className="w-full lg:w-auto">
                <SearchBox
                  placeholder={t("Search Vendor/Order No")}
                  searchResult={handleSearchChange}
                />
              </div>

              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-stretch sm:items-end justify-end w-full lg:w-auto">
                <DateFilter
                  setSelectedRange={setSelectedRange}
                  selectedRange={selectedRange}
                  SubmitFilter={(start, date) => {
                    setSearchKeyword("");
                    setStartDate(start);
                    setEndDate(date);
                    getSessionList("", selectedPaymentType, 0, start, date);
                  }}
                />

                <SelectBox
                  style={{ width: 140 }}
                  width={200}
                  placeholder={t("all_orders")}
                  name="filter"
                  onChange={handlePaymentTypeChange}
                  options={options}
                  value={selectedPaymentType}
                />
              </div>
            </div>
            <>
              <div className="flex justify-between items-center"></div>
              {data?.length < 1 ? (
                <p className="text-center text-red-500 mt-20">
                  {t("No Orders Found")}
                </p>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 mt-1 mb-4">
                  {data?.map((val, i) => (
                    <div
                      key={i}
                      className="w-[357px] md:w-full h-30 shadow-sm hover:shadow-lg rounded-xl bg-[#FFFFFF] mt-4 pb-2 cursor-pointer p-4"
                      onClick={() => handleBoxClick(val)}
                    >
                      <div className="flex flex-col justify-between mb-2">
                        <div className="flex flex-row justify-between font-medium text-lg text-[#272728]">
                          <span className="font-semibold">
                            {val?.order_details?.partner_name}
                          </span>
                          {val?.order_details?.status == "cancel" ? (
                            <span
                              className={`font-medium text-sm justify-end rounded-full bg-[#ffd1d1] text-[#ef3a3a]`}
                              style={{
                                display: "inline-block",
                                padding: "0.5rem 1rem",
                              }}
                            >
                              {t("Cancelled")}
                            </span>
                          ) : (
                            <span
                              className={`font-medium text-sm justify-end rounded-full ${
                                val?.order_details?.payment_status === "partial"
                                  ? "bg-[#FFEBC5] text-[#E8A700]" // Partial Payment
                                  : val?.order_details?.payment_status ===
                                        "not_paid" &&
                                      val?.order_details?.total_amount > 0
                                    ? "bg-[#FFEBC5] text-[#E8A700]" // Not Paid
                                    : val?.order_details?.payment_status ===
                                        "paid"
                                      ? "bg-[#D1FFDE] text-[#00B833]" // Full Payment
                                      : "text-white" // Default case
                              }`}
                            style={{
                              display: "inline-block",
                              padding: "0.5rem 1rem",
                            }}
                          >
                            {t(
                              formatSessionState(
                                t(val?.order_details?.payment_status),
                              ),
                            )}
                          </span>
                          )}
                          {val.order_details.status === "draft" && (
                            <span
                              className="text-sm text-red cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(val);
                              }}
                            >
                              {t("Delete")}
                            </span>
                          )}

                          {val.order_details.total_amount < 0 &&
                            val?.order_details?.status !== "draft" && (
                              <span
                                className="text-sm bg-[#fbded9] rounded-full text-red"
                                style={{
                                  display: "inline-block",
                                  padding: "0.5rem 1rem",
                                }}
                              >
                                {t("Return")}
                              </span>
                            )}
                        </div>
                      </div>

                      {/* Details */}
                      <div className="space-y-2 mt-3">
                        {allStores && (
                          <p className="flex flex-row flex-wrap font-semibold text-sm">
                            {t("Store Name")}:
                            <span className="font-normal ms-2">
                              {val.order_details.store_name}
                            </span>
                          </p>
                        )}

                        {val.order_details?.order_no ? (
                          <p className="flex flex-row flex-wrap font-semibold text-sm">
                            {t("Order No.")}:
                            <span className="font-normal ms-2">
                              {val.order_details.order_no}
                            </span>
                          </p>
                        ) : (
                          <p className="font-semibold text-gray-500 text-sm">
                            {t("Draft Order")}
                          </p>
                        )}

                        <p className="flex flex-row flex-wrap font-semibold text-sm">
                          {t("Bill No.")}:
                          <span className="font-normal ms-2">
                            {val.order_details.venfor_ref || "--"}
                          </span>
                        </p>

                        <p className="flex flex-row flex-wrap font-semibold text-sm">
                          {t("Bill Date")}:
                          <span className="font-normal ms-2">
                            {val.order_details?.order_date
                              ? moment(val.order_details?.order_date).format(
                                  "YYYY-MM-DD",
                                )
                              : "N/A"}
                          </span>
                        </p>

                        {val.order_details?.payment_term && (
                          <p className="flex flex-row flex-wrap font-semibold text-sm">
                            {t("Payment Term")}:
                            <span className="font-normal ms-2">
                              {val.order_details.payment_term}
                            </span>
                          </p>
                        )}

                        <p className="flex flex-row flex-wrap font-semibold text-sm">
                          {t("Create Date")}:
                          <span className="font-normal ms-2">
                            {val.order_details?.create_date
                              ? moment(val.order_details?.create_date).format(
                                  "YYYY-MM-DD",
                                )
                              : "N/A"}
                          </span>
                        </p>

                        <p className="flex flex-row flex-wrap font-semibold text-sm">
                          {t("Due Date")}:
                          <span className="font-normal ms-2">
                            {val.order_details?.due_date
                              ? moment(val.order_details?.due_date).format(
                                  "YYYY-MM-DD",
                                )
                              : "N/A"}
                          </span>
                        </p>
                      </div>

                      {/* Bottom Cards */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-4">
                        <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                          <p className="font-normal text-sm">{t("Quantity")}</p>
                          <p className="text-sm">
                            {val.lines.reduce(
                              (sum, line) => sum + line.product_qty,
                              0,
                            )}
                          </p>
                        </div>

                        <div className="bg-[#F6F6F6] p-2 rounded-lg text-center">
                          <p className="font-normal text-sm">
                            {t("Invoice Value")}
                          </p>
                          <p className="text-sm">
                            {val.order_details.total_amount.toFixed(2) || 0}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>

            {/* Pagination */}
            {data?.length > 0 && (
              <div className="flex flex-row justify-between items-center gap-4 mt-4 mb-4">
                <button
                  onClick={() => {
                    if (currentPage > 1) {
                      setCurrentPage(currentPage - 1);
                      getSessionList(
                        searchKeyword,
                        selectedPaymentType,
                        currentPage - 2,
                        startDate,
                        endDate,
                      );
                    }
                  }}
                  className={`w-24 h-10 rounded-lg bg-primaryBlue text-white ${
                    currentPage === 1
                      ? "opacity-50 cursor-not-allowed"
                      : "text-white"
                  }`}
                  disabled={currentPage === 1}
                >
                  {t("Previous")}
                </button>

                <span>
                  {t("Page")} {currentPage}
                </span>

                <button
                  onClick={() => {
                    if (fetchedOrdersCount === 10) {
                      setCurrentPage(currentPage + 1);
                      getSessionList(
                        searchKeyword,
                        selectedPaymentType,
                        currentPage,
                        startDate,
                        endDate,
                      );
                    }
                  }}
                  className={`w-20 h-10 rounded-lg bg-primaryBlue text-white ${
                    fetchedOrdersCount < 10
                      ? "opacity-50 cursor-not-allowed"
                      : "text-white"
                  }`}
                  disabled={fetchedOrdersCount < 10}
                >
                  {t("Next")}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalVisible && (
        <PurchasePayment
          isOpen={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          bill_id={selectedBillId}
          due_amount={selectedDueAmount}
          Popup={() => {
            setpopup(true);
          }}
        />
      )}

      <Drawer
        title={t("Payment History")}
        placement="right"
        width={window.innerWidth < 768 ? "100%" : 500}
        onClose={onClose}
        visible={visible}
      >
        {loading ? (
          <LoadingSpinner />
        ) : (
          <div>
            {paymentHistoryData.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="w-full min-w-[500px]">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="p-2 text-left">{t("Payment Date")}</th>
                      <th className="p-2 text-left">{t("Type")}</th>
                      <th className="p-2 text-left">{t("Amount")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paymentHistoryData.map((payment, index) => (
                      <tr key={index} className="border-b">
                        <td className="p-2">
                          {moment(payment.payment_date).format("YYYY-MM-DD")}
                        </td>
                        <td className="p-2">{payment.type}</td>
                        <td className="p-2">{payment.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>{t("No payment history available")}</p>
            )}
          </div>
        )}
      </Drawer>
    </>
  );
};

export default PurchaseList;
